"use strict";

var StructuredSource = require('./structured-source.js')["default"];

module.exports = StructuredSource;
/* vim: set sw=4 ts=4 et tw=80 : */